import React from 'react';
import { connect } from 'react-redux';
import constants from '../../constants/ErrorBoundaryTranslation.json';
import { notifyBugsnag } from '../../actions/tools/BugsnagActions';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidMount() {
    window.onerror = this.logError;
  }

  componentDidCatch(error, errorInfo) {
    // Display fallback UI
    this.setState({ hasError: true });
    this.logError(error, errorInfo);
  }

  logError = (error, errorInfo) => {
    // Only try to notify Bugsnag if dispatch is available
    if (this.props.dispatch) {
      try {
        this.props.dispatch(
          notifyBugsnag(error, {
            metadata: {
              error: JSON.stringify([error, errorInfo]),
            },
          })
        );
      } catch (err) {
        console.error('Failed to notify Bugsnag:', err);
      }
    } else {
      // Fallback: just log to console if dispatch not available
      console.error('ErrorBoundary caught error:', error, errorInfo);
    }
  };

  render() {
    if (this.state.hasError && !this.props.noMessage) {
      return <h1>{constants.error_message}</h1>;
    }
    return this.props.children;
  }
}

export default connect()(ErrorBoundary);

export const withErrorBoundary = Component => props =>
  (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );
